import React from 'react';
import { Modal } from 'antd';
import classNames from 'classnames';

import MarkdownPreview from '@uiw/react-markdown-preview';

export default function AnalysisModal({ open, onClose, title, content }) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={800}
      classNames={{ content: '!bg-white !max-h-[95vh] overflow-y-auto' }}
    >
      {title && <h2 className="text-3xl font-bold mb-4 text-center text-black">{title}</h2>}
      <MarkdownPreview className={classNames('!bg-transparent markdown-preview !text-black')} source={content} />
    </Modal>
  );
}
